/* ==========================================================================
   Ilersis · formularios de Shopify Forms (Coopernicode)

   Shopify Forms pinta el formulario dentro de un shadow DOM. Las variables de
   color y tipografía ya llegan desde assets/ilersis-forms.css; este script
   añade dentro del shadow DOM lo que no se puede tocar desde fuera:

   - etiquetas en mayúsculas encima del campo (como el resto de formularios),
   - nombre / apellidos / correo / teléfono a dos columnas cuando hay sitio,
   - casilla, opciones, botón y zona de adjuntos con el estilo de la casa,
   - rellenar campos ocultos al usuario (p. ej. el producto en la ficha) con
     data-ilx-prefill='{"producto":"…"}' en el contenedor,
   - variantes según el contenedor: .ilx-forms-slot--dark (sobre fondo oscuro,
     p. ej. la franja del boletín) e .ilx-forms-slot--inline (correo y botón
     en la misma línea cuando hay sitio).

   Es una mejora: si la app cambia su marcado interno y algún selector deja de
   coincidir, el formulario sigue funcionando con el estilo de las variables.
   ========================================================================== */
(function () {
  if (window.__ilxForms) return;
  window.__ilxForms = true;

  var F = 'Raleway, sans-serif';
  var CSS = [
    /* Sin márgenes ni recortes propios: el panel del tema manda */
    'section[class*="_inline_"],[class*="_formContainer_"]{overflow:visible!important;margin:0!important;max-width:none!important}',
    'form[class*="_formFieldset_"]{padding:0 1px!important}',
    /* En móvil la app centra el formulario en una rejilla de ancho «auto»; con la rejilla de abajo
       (container-type) eso lo dejaba a 0 px de ancho. Forzamos que ocupe todo el panel. */
    '[class*="_container_"]{grid-template-columns:minmax(0,1fr)!important;justify-content:stretch!important}',
    '[class*="_container_"]>div,section[class*="_inline_"],[class*="_formContainer_"],[class*="_gridItemContent_"]{width:100%!important;max-width:none!important;min-width:0}',

    /* Cabecera del formulario */
    '[class*="_formHeader_"]{text-align:left;margin:0 0 28px}',
    'h2[class*="_textHeading_"]{font:800 clamp(22px,2vw,28px)/1.15 ' + F + ';letter-spacing:-.02em;color:#000;margin:0 0 8px;text-wrap:balance}',
    '[class*="_formHeader_"] [class*="_textBody_"]{font:500 16px/1.55 ' + F + ';color:#4a4a4a}',

    /* Rejilla: una columna; dos cuando el panel mide 520px o más */
    '[class*="_gridItemContent_"]{container-type:inline-size}',
    'form[class*="_formFieldset_"]{display:grid;grid-template-columns:minmax(0,1fr);gap:20px 24px;padding:0}',
    'form[class*="_formFieldset_"]>*{order:5;min-width:0}',
    'form[class*="_formFieldset_"]>div:has(>#first_name){order:1}',
    'form[class*="_formFieldset_"]>div:has(>#last_name){order:2}',
    'form[class*="_formFieldset_"]>div:has(>#email){order:3}',
    'form[class*="_formFieldset_"]>[class*="_formPhoneInputContainer_"]{order:4}',
    'form[class*="_formFieldset_"]>fieldset[class*="_checkboxFieldSet_"]{order:8}',
    'form[class*="_formFieldset_"]>button[type="submit"]{order:9}',
    '@container (min-width:520px){' +
      'form[class*="_formFieldset_"]{grid-template-columns:repeat(2,minmax(0,1fr))}' +
      'form[class*="_formFieldset_"]>*{grid-column:1/-1}' +
      'form[class*="_formFieldset_"]>div:has(>#first_name),' +
      'form[class*="_formFieldset_"]>div:has(>#last_name),' +
      'form[class*="_formFieldset_"]>div:has(>#email),' +
      'form[class*="_formFieldset_"]>[class*="_formPhoneInputContainer_"]{grid-column:auto}' +
      'form[class*="_formFieldset_"]:not(:has(#first_name)) >div:has(>#email){grid-column:1/-1}' +
    '}',

    /* Etiquetas encima del campo, en versalitas pequeñas */
    '[class*="_formFieldContainer_"]{display:flex;flex-direction:column;gap:8px}',
    'label[class*="_formInputFieldLabel_"]{position:static!important;top:auto!important;left:auto!important;transform:none!important;order:-1;width:auto!important;max-width:none!important;' +
      'font:700 13px/1.3 ' + F + '!important;letter-spacing:.08em;text-transform:uppercase;color:#232323!important;white-space:normal;overflow:visible}',
    '[class*="_formFileInput_"]>p,legend[class*="_checkboxLegend_"],legend[class*="_radioLegend_"]{font:700 13px/1.3 ' + F + ';letter-spacing:.08em;text-transform:uppercase;color:#232323;margin:0 0 8px;padding:0}',

    /* Campos */
    'input[class*="_formInputField_"],input[class*="_formPhoneInputField_"],textarea[class*="_textArea_"]{padding:13px 14px!important;font:500 16px/1.4 ' + F + '!important;background:#fff;color:#232323}',
    'input[class*="_formInputField_"]:hover,input[class*="_formPhoneInputField_"]:hover,textarea[class*="_textArea_"]:hover{box-shadow:0 0 0 1px #5c5c5c}',
    'textarea[class*="_textArea_"]{min-height:132px;resize:vertical;line-height:1.6!important}',
    '[class*="_formFieldContainer_"]:has(textarea)::before{display:none!important}',
    '[class*="_formPhoneInputContainer_"]{align-items:end;gap:8px;width:auto}',
    '[class*="_formPhoneInputContainer_"] [class*="_selectToggle_"]{max-height:none;height:48px;padding:0 12px}',

    /* Adjuntar archivo */
    '[class*="_formFileInputField_"]{border:1px dashed #bdb8ad!important;background:#fff;margin-top:0}',
    '[class*="_formFileInputField_"]:hover{border-color:#232323!important}',
    '[class*="_formFileInputContent_"]{padding:22px 16px}',
    '[class*="_formFileInputButton_"]{display:inline-flex;align-items:center;padding:11px 18px;border-radius:0;background:#F0BF5C!important;color:#232323!important;' +
      'font:800 13px/1.2 ' + F + '!important;letter-spacing:.08em;text-transform:uppercase}',
    '[class*="_formFileInputField_"]:hover [class*="_formFileInputButton_"]{background:#e8b04a!important}',
    '[class*="_formFileInputFileName_"]{font:600 15px/1.4 ' + F + '}',

    /* Casillas (privacidad, boletín) */
    'fieldset[class*="_checkboxFieldSet_"]{margin:0;padding:0;border:0}',
    '[class*="_checkboxField_"]{grid-template-columns:18px minmax(0,1fr)!important;gap:12px!important;align-items:start!important;cursor:pointer}',
    'input[class*="_checkboxInput_"]{width:18px!important;height:18px!important;margin:2px 0 0!important;accent-color:#232323}',
    '[class*="_checkboxField_"] [class*="_textBody_"]{font:500 15px/1.55 ' + F + ';color:#4a4a4a}',

    /* Opciones de una sola respuesta (p. ej. importe en Colabora): fichas en fila */
    'fieldset[class*="_radioFieldSet_"]{margin:0;padding:0;border:0;min-width:0}',
    'fieldset[class*="_radioFieldSet_"]>div{display:flex!important;flex-direction:row!important;flex-wrap:wrap!important;align-items:center;gap:10px!important}',
    'label[class*="_radioField_"]{display:inline-flex!important;flex:0 0 auto!important;width:auto!important;align-items:center;gap:10px;margin:0!important;padding:11px 16px;background:#fff;box-shadow:0 0 0 1px #d7d4cd;cursor:pointer;transition:box-shadow .15s ease}',
    'label[class*="_radioField_"]:hover{box-shadow:0 0 0 1px #5c5c5c}',
    'label[class*="_radioField_"]:has(input:checked){box-shadow:0 0 0 2px #232323}',
    'label[class*="_radioField_"]:has(input:focus-visible){outline:2px solid #A8730F;outline-offset:3px}',
    'input[class*="_radioInput_"]{width:16px!important;height:16px!important;margin:0!important;accent-color:#232323}',
    'label[class*="_radioField_"] [class*="_textBody_"]{font:600 15px/1.3 ' + F + ';color:#232323}',

    /* Botón: negro, mayúsculas, dorado al pasar */
    'button[class*="_formSubmitButton_"]{box-sizing:border-box;max-width:100%;justify-self:start;width:auto;min-width:0;padding:15px 28px!important;border-radius:0!important;background:#232323!important;color:#fff!important;' +
      'font:800 13px/1 ' + F + '!important;letter-spacing:.12em;text-transform:uppercase;filter:none!important;transition:background .15s ease,color .15s ease}',
    'button[class*="_formSubmitButton_"]:hover,button[class*="_formSubmitButton_"]:focus-visible{background:#F0BF5C!important;color:#232323!important}',
    '@container (max-width:519px){button[class*="_formSubmitButton_"]{justify-self:stretch;width:100%}}',

    /* Texto legal y mensajes */
    '[class*="_formDisclaimer_"]{text-align:left!important;margin:18px 0 0!important;font:500 13px/1.55 ' + F + '!important;color:#5c5c5c}',
    '[class*="_formDisclaimer_"] a,[class*="_textBody_"] a{color:#bf570a;text-decoration:underline;text-underline-offset:3px}',
    '[class*="_formDisclaimer_"] a:hover,[class*="_textBody_"] a:hover{color:#232323}',
    'output,[role="alert"]{font:600 14px/1.4 ' + F + '}'
  ].join('\n');

  /* Sobre fondo oscuro: textos claros y botón en el amarillo de marca */
  var DARK = [
    'label[class*="_formInputFieldLabel_"]{color:#fff!important}',
    '[class*="_formFileInput_"]>p,legend[class*="_checkboxLegend_"],legend[class*="_radioLegend_"]{color:#fff}',
    '[class*="_checkboxField_"] [class*="_textBody_"]{color:rgba(255,255,255,.86)}',
    'h2[class*="_textHeading_"]{color:#fff}',
    '[class*="_formHeader_"] [class*="_textBody_"],[class*="_textBody_"]{color:rgba(255,255,255,.86)}',
    'button[class*="_formSubmitButton_"]{background:#F0BF5C!important;color:#232323!important}',
    'button[class*="_formSubmitButton_"]:hover,button[class*="_formSubmitButton_"]:focus-visible{background:#fff!important;color:#232323!important}',
    '[class*="_formDisclaimer_"]{color:rgba(255,255,255,.72)!important}',
    '[class*="_formDisclaimer_"] a,[class*="_textBody_"] a{color:#F0BF5C}',
    '[class*="_formDisclaimer_"] a:hover,[class*="_textBody_"] a:hover{color:#fff}',
    'input[class*="_checkboxInput_"],input[class*="_radioInput_"]{accent-color:#F0BF5C}',
    'output,[role="alert"]{color:#ffb4a8}'
  ].join('\n');

  /* Correo y botón en la misma línea (boletín) cuando el hueco mide 400px o más.
     Solo se aplica a formularios cortos (sin nombre ni mensaje). */
  var INLINE = [
    '@container (min-width:400px){' +
      'form[class*="_formFieldset_"]:not(:has(#first_name,textarea)){grid-template-columns:minmax(0,1fr) auto!important;gap:16px 12px}' +
      'form[class*="_formFieldset_"]:not(:has(#first_name,textarea))>*{grid-column:1/-1!important}' +
      'form[class*="_formFieldset_"]:not(:has(#first_name,textarea))>div:has(>#email){grid-column:1!important}' +
      'form[class*="_formFieldset_"]:not(:has(#first_name,textarea))>button[type="submit"]{order:4;grid-column:2!important;align-self:end;justify-self:stretch;width:auto;min-height:50px}' +
    '}'
  ].join('\n');

  function mk(css) {
    try { var sh = new CSSStyleSheet(); sh.replaceSync(css); return sh; } catch (e) { return null; }
  }
  var SHEETS = { base: { css: CSS, sheet: mk(CSS) }, dark: { css: DARK, sheet: mk(DARK) }, inline: { css: INLINE, sheet: mk(INLINE) } };

  function add(root, name) {
    var it = SHEETS[name];
    if (it.sheet && root.adoptedStyleSheets) {
      if (root.adoptedStyleSheets.indexOf(it.sheet) === -1) root.adoptedStyleSheets = root.adoptedStyleSheets.concat([it.sheet]);
    } else if (!root.querySelector('style[data-ilx-forms="' + name + '"]')) {
      var s = document.createElement('style');
      s.setAttribute('data-ilx-forms', name);
      s.textContent = it.css;
      root.appendChild(s);
    }
  }

  function style(root, host) {
    add(root, 'base');
    if (host.closest('.ilx-forms-slot--dark')) add(root, 'dark');
    if (host.closest('.ilx-forms-slot--inline')) add(root, 'inline');
  }

  /* Rellena campos a partir de data-ilx-prefill del contenedor.
     Se busca el campo por el final de su nombre (custom#producto → «producto»). */
  function prefill(host, root) {
    var box = host.closest('[data-ilx-prefill]');
    if (!box) return;
    var data;
    try { data = JSON.parse(box.getAttribute('data-ilx-prefill')); } catch (e) { return; }
    Object.keys(data).forEach(function (key) {
      var el = root.querySelector('[name$="' + key + '"],[id$="' + key + '"]');
      if (!el || el.value || el.__ilxFilled) return;
      el.__ilxFilled = true;
      var proto = el.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
      var setter = Object.getOwnPropertyDescriptor(proto, 'value').set;
      setter.call(el, String(data[key]));
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function watch(host) {
    if (host.__ilxWatched) return;
    var root = host.shadowRoot;
    if (!root) return;
    host.__ilxWatched = true;
    var run = function () { style(root, host); prefill(host, root); };
    run();
    /* La app vuelve a pintar al cambiar de paso (formulario → gracias) y puede
       reasignar sus hojas de estilo: lo comprobamos en cada cambio. */
    new MutationObserver(run).observe(root, { childList: true, subtree: true });
  }

  function scan() {
    var hosts = document.querySelectorAll('shopify-forms-embed');
    for (var i = 0; i < hosts.length; i++) watch(hosts[i]);
  }

  scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  /* El shadow DOM se adjunta después de insertar el elemento: unos reintentos. */
  var n = 0, t = setInterval(function () { scan(); if (++n > 40) clearInterval(t); }, 500);
})();
